import { DocumentFileFormatEnum } from '@/generated/graphql/types';

export const isPdfOrDocxFile = (type?: DocumentFileFormatEnum | null) =>
  type === DocumentFileFormatEnum.DocumentPdf ||
  type === DocumentFileFormatEnum.DocumentDocx;

export const isImageFile = (type?: DocumentFileFormatEnum | null) =>
  type === DocumentFileFormatEnum.DocumentJpg ||
  type === DocumentFileFormatEnum.DocumentPng;
